import React, { useEffect } from 'react';
import { Button, Form, Input, Modal, notification } from 'antd';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import FormLabel from '../../../components/FormLabel';
import NormalFormLabel from '../../../components/NormalFormLabel';
import { useMutation } from '@tanstack/react-query';
import CustomSelect from '../../../components/CustomSelect';
import { updatePartnerRequest } from '../../../services/partnerRequest';
import { validatePhoneNumber } from '../../../utils/validate';
import { LIST_STATUS_PARTNER } from '../../../constants/appSelect';

const SuaDoiTac = ({ Confirm, visible, selectedPartnerId, refetchDataPartners }) => {
  const [form] = Form.useForm();

  const { mutate: mutateUpdatePartner, isPending: isLoadingUpdatePartner } = useMutation({
    mutationFn: (data) => updatePartnerRequest(data, selectedPartnerId?.id),
    onSuccess: async (data) => {
      if (data?.status) {
        notification.success({
          message: 'Cập nhật người dùng thành công!',
        });
        refetchDataPartners();
        handleCancel();
      } else {
        notification.error({
          message: data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!',
        });
      }
    },
    onError: (error) => {
      notification.error({ message: error?.data?.showMessage || 'Có lỗi xảy ra vui lòng thử lại sau!' });
    },
  });

  // Update form fields when selectedPartnerId changes
  useEffect(() => {
    if (selectedPartnerId) {
      form.setFieldsValue({
        name: selectedPartnerId.name,
        description: selectedPartnerId.description,
        phone: selectedPartnerId.phone,
        email: selectedPartnerId.email,
        address: selectedPartnerId.address,
        status: selectedPartnerId.status,
      });
    }
  }, [selectedPartnerId, form]);

  const handleCancel = () => {
    Confirm(false);
  };

  const onFinish = (values) => {
    mutateUpdatePartner(values);
  };

  return (
    <Modal title="Sửa đối tác" open={visible} onCancel={handleCancel} footer={null} width={840}>
      <Form form={form} layout="vertical" onFinish={onFinish} requiredMark={false}>
        <Form.Item
          label={<FormLabel text="Tên đối tác" />}
          name="name"
          rules={[{ required: true, message: 'Vui lòng nhập tên đối tác' }]}
        >
          <Input allowClear placeholder="Nhập tên đối tác......" />
        </Form.Item>

        <Form.Item label={<NormalFormLabel text="Mô tả" />} name="description">
          <Input allowClear placeholder="Nhập mô tả......" />
        </Form.Item>

        <Form.Item
          label={<NormalFormLabel text="Số điện thoại" />}
          name="phone"
          rules={[
            () => ({
              validator(_, value) {
                if (value && !validatePhoneNumber(value)) {
                  return Promise.reject(new Error('Số điện thoại không đúng định dạng'));
                }

                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input allowClear type="number" placeholder="Nhập số điện thoại......" />
        </Form.Item>

        <Form.Item label={<NormalFormLabel text="Email" />} name="email">
          <Input
            allowClear
            placeholder="Nhập email......"
            rules={[{ type: 'email', message: 'Email không đúng định dạng' }]}
          />
        </Form.Item>

        <Form.Item label={<NormalFormLabel text="Địa chỉ" />} name="address">
          <Input allowClear placeholder="Nhập địa chỉ......" />
        </Form.Item>

        <Form.Item
          label={<FormLabel text="Trạng thái" />}
          name="status"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái' }]}
        >
          <CustomSelect
            placeholder="Chọn trạng thái"
            options={[LIST_STATUS_PARTNER[0], LIST_STATUS_PARTNER[1], LIST_STATUS_PARTNER[3]]}
          />
        </Form.Item>

        <div className="flex justify-end gap-3">
          <Button onClick={handleCancel}>
            <CloseOutlined /> Hủy bỏ
          </Button>
          <Button loading={isLoadingUpdatePartner} type="primary" htmlType="submit">
            <SaveOutlined /> Lưu lại
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default SuaDoiTac;
